import * as React from 'react'
import { Space, Select, Input, Radio, RadioChangeEvent, Typography, Switch } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { BlocsPdv } from './MainCSoftAccess';
const { Text } = Typography;
const { Option } = Select;

interface IProps {
  filesPdv: Array<[string, string]>
  pdvBlocs: BlocsPdv
  setPdvBlocs: React.Dispatch<React.SetStateAction<BlocsPdv>>
}

export default function CBlocksPdv(props: IProps) {

  return (
    <div id="blocs-pdv" style={{ maxWidth: '1000px' }}>
      {['0', '1', '2', '3', '4'].map((idBlockPdv: string, index: number) => (
        <div key={idBlockPdv} id={idBlockPdv} className='div-switch'>
          {/* Switch to display or not the fields of the pdv block's informations */}
          <Switch
            id={`pdv_bloc${idBlockPdv}_displayed`}
            checkedChildren={<CheckOutlined />}
            unCheckedChildren={<CloseOutlined />}
            checked={props.pdvBlocs.pdvBlocNotEmpty[index]}
            style={{ marginRight: '15px' }}
            onChange={(checked: boolean) => {
              const updatedPdvBlocNotEmptyValues = [...props.pdvBlocs.pdvBlocNotEmpty]
              updatedPdvBlocNotEmptyValues[index] = checked
              props.setPdvBlocs({
                ...props.pdvBlocs,
                pdvBlocNotEmpty: updatedPdvBlocNotEmptyValues
              })
            }}
          />
          <b style={{ fontSize: '17px' }}>Bloc {idBlockPdv}</b>

          {props.pdvBlocs.pdvBlocNotEmpty[index] && (
            <Space style={{ width: '100%' }} direction="vertical">
              {/* Select the file_pdv for the block among a given list */}
              <div className="div-text-input">
                <Text className='text-before-input'>Fichier Pdv</Text>
                <Select
                  id={`pdv_blocs_bloc${idBlockPdv}_file_id`}
                  style={{ borderRadius: '4px' }}
                  showSearch
                  optionFilterProp="label"
                  value={props.pdvBlocs.pdv_blocs[`bloc${idBlockPdv}`].file_id}
                  onChange={(selectedFile) => {
                    props.setPdvBlocs({
                      ...props.pdvBlocs,
                      pdv_blocs: {
                        ...props.pdvBlocs.pdv_blocs,
                        [`bloc${idBlockPdv}`]: {
                          ...props.pdvBlocs.pdv_blocs[`bloc${idBlockPdv}`],
                          file_id: selectedFile
                        }
                      }
                    })
                  }}
                >
                  {props.filesPdv.map(([value, label]) => (
                    <Option key={value} value={value} label={label}>
                      {label}
                    </Option>
                  ))}
                </Select>
              </div>
              {/* Choose the name of the block */}
              <div className="div-text-input">
                <Text className='text-before-input'>Nom</Text>
                <Input
                  id={`pdv_blocs_bloc${idBlockPdv}_name`}
                  style={{ borderRadius: '4px' }}
                  value={props.pdvBlocs.pdv_blocs[`bloc${idBlockPdv}`].name}
                  onChange={(e) => {
                    props.setPdvBlocs({
                      ...props.pdvBlocs,
                      pdv_blocs: {
                        ...props.pdvBlocs.pdv_blocs,
                        [`bloc${idBlockPdv}`]: {
                          ...props.pdvBlocs.pdv_blocs[`bloc${idBlockPdv}`],
                          name: e.target.value
                        }
                      }
                    })
                  }}
                />
              </div>
              {/* Choose to display or not : "bouton carte" */}
              <div className="div-text-input">
                <Text className='text-before-input'>Afficher bouton carte ?</Text>
                <Radio.Group
                  id={`pdv_blocs_bloc${idBlockPdv}_display_btn`}
                  value={props.pdvBlocs.pdv_blocs[`bloc${idBlockPdv}`].display_btn}
                  onChange={(e: RadioChangeEvent) => {
                    props.setPdvBlocs({
                      ...props.pdvBlocs,
                      pdv_blocs: {
                        ...props.pdvBlocs.pdv_blocs,
                        [`bloc${idBlockPdv}`]: {
                          ...props.pdvBlocs.pdv_blocs[`bloc${idBlockPdv}`],
                          display_btn: e.target.value
                        }
                      }
                    })
                  }}
                >
                  <Radio value={true}>Oui</Radio>
                  <Radio value={false}>Non</Radio>
                </Radio.Group>
              </div>
              {/* Choose to display or not : "lien google map" */}
              <div className="div-text-input">
                <Text className='text-before-input'>Afficher lien google map ?</Text>
                <Radio.Group
                  id={`pdv_blocs_bloc${idBlockPdv}_display_gmap_url`}
                  value={props.pdvBlocs.pdv_blocs[`bloc${idBlockPdv}`].display_gmap_url}
                  onChange={(e: RadioChangeEvent) => {
                    props.setPdvBlocs({
                      ...props.pdvBlocs,
                      pdv_blocs: {
                        ...props.pdvBlocs.pdv_blocs,
                        [`bloc${idBlockPdv}`]: {
                          ...props.pdvBlocs.pdv_blocs[`bloc${idBlockPdv}`],
                          display_gmap_url: e.target.value
                        }
                      }
                    })
                  }}
                >
                  <Radio value={true}>Oui</Radio>
                  <Radio value={false}>Non</Radio>
                </Radio.Group>
              </div>
              {/* Choose to allow : "export excel" */}
              <div className="div-text-input">
                <Text className='text-before-input'>Export excel ?</Text>
                <Radio.Group
                  id={`pdv_blocs_bloc${idBlockPdv}_excel_export`}
                  value={props.pdvBlocs.pdv_blocs[`bloc${idBlockPdv}`].excel_export}
                  onChange={(e: RadioChangeEvent) => {
                    props.setPdvBlocs({
                      ...props.pdvBlocs,
                      pdv_blocs: {
                        ...props.pdvBlocs.pdv_blocs,
                        [`bloc${idBlockPdv}`]: {
                          ...props.pdvBlocs.pdv_blocs[`bloc${idBlockPdv}`],
                          excel_export: e.target.value
                        }
                      }
                    })
                  }}
                >
                  <Radio value={true}>Oui</Radio>
                  <Radio value={false}>Non</Radio>
                </Radio.Group>
              </div>

              <div className="div-text-input">
                <Text className='text-before-input'>Catégories de même couleur ?</Text>
                <Radio.Group
                  id={`pdv_blocs_bloc${idBlockPdv}_pdvs_unicolor`}
                  value={props.pdvBlocs.pdv_blocs[`bloc${idBlockPdv}`].pdvs_unicolor}
                  onChange={(e: RadioChangeEvent) => {
                    props.setPdvBlocs({
                      ...props.pdvBlocs,
                      pdv_blocs: {
                        ...props.pdvBlocs.pdv_blocs,
                        [`bloc${idBlockPdv}`]: {
                          ...props.pdvBlocs.pdv_blocs[`bloc${idBlockPdv}`],
                          pdvs_unicolor: e.target.value
                        }
                      }
                    })
                  }}
                >
                  <Radio value={true}>Oui</Radio>
                  <Radio value={false}>Non</Radio>
                </Radio.Group>
              </div>

              <div className="div-text-input">
                <Text className='text-before-input'>Ajouter/supprimer des pdvs?</Text>
                <Radio.Group
                  id={`pdv_blocs_bloc${idBlockPdv}_pdvs_addDelete`}
                  value={props.pdvBlocs.pdv_blocs[`bloc${idBlockPdv}`].add_delete_authorized}
                  onChange={(e: RadioChangeEvent) => {
                    props.setPdvBlocs({
                      ...props.pdvBlocs,
                      pdv_blocs: {
                        ...props.pdvBlocs.pdv_blocs,
                        [`bloc${idBlockPdv}`]: {
                          ...props.pdvBlocs.pdv_blocs[`bloc${idBlockPdv}`],
                          add_delete_authorized: e.target.value
                        }
                      }
                    })
                  }}
                >
                  <Radio value={true}>Oui</Radio>
                  <Radio value={false}>Non</Radio>
                </Radio.Group>
              </div>
            </Space>
          )}
        </div>
      ))}
    </div>
  )
}
